export class QcReportDetailDTO {
    id: string;
    reportDateTime: Date;
    plateName: string;
    plateQCStatus: PlateQCStatusList;
    qcParams: EurofinsControlParamsDTO[];
    contiguousReadLengthAvg: number;
    contiguousReadLengthMax: number;
    contiguousReadLengthMin: number;
    contiguousBaseCutOff: number;
    baseCallStartRange: string;
    avgSignalIntensityRange: string;
    baseCallStartFailedNumber: number;
    baseCallStartFailedPercentage: number;
    dyeBlobsFailedNumber: number;
    dyeBlobsFailedPercentage: number;
    contiguousReadsFailedNumber: number;
    contiguousReadsFailedPercentage: number;
    avgSignalIntensityFailedNumber: number;
    avgSignalIntensityFailedPercentage: number;
    mixedSeqFailedNumber: number;
    mixedSeqFailedPercentage: number;
    missingSeqFailedNumber: number;
    missingSeqFailedPercentage: number;
    numberOfFiles: number;
    numberOfEmptyFiles: number;
    numberOfFilesUsed: number;
    action: string;
    mapOfPositionAndReportDetails: any;


}
export interface EurofinsControlParamsDTO {
    status: string;
    control: string;
    usedPrimer: string;
    guessPrimer: string;
    range: string;
    lengthOfControl: string;
    match: string;

}
export enum PlateQCStatusList {
    OK,
    NOQC,
    QCFAILED,
    FAILED,
    TRASH
}
